import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import Layout, { PageHero } from "@/components/Layout";
import LeadForm from "@/components/LeadForm";
import { Reveal, Overline } from "@/components/Reveal";
import { MEDIA } from "@/lib/content";

const PILLARS = [
  { title: "Real Estate", body: "Commercial brokerage, owner advisory, dispositions, and off-market acquisitions." },
  { title: "Capital", body: "Creative finance, sale-leasebacks, syndication, and investor matching." },
  { title: "Media", body: "AI-powered marketing and automation that compounds visibility and follow-up." },
  { title: "Private Deal Flow", body: "A network of owners, investors, and operators trading real opportunities." },
];

export default function MichaelBrown() {
  return (
    <Layout>
      <PageHero
        overline="The Strategist"
        title="Michael Brown"
        subtitle="Commercial real estate broker and business strategist helping owners, investors, and operators structure better outcomes through real estate, capital, media, and private deal flow."
        image={MEDIA.executive}
      />

      <section className="py-16 max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-start">
        <Reveal>
          <img src={MEDIA.executive} alt="Michael Brown" className="w-full aspect-[4/5] object-cover grayscale" />
        </Reveal>
        <Reveal delay={0.1}>
          <Overline>Positioning</Overline>
          <h2 className="font-display text-3xl font-bold mt-3">Structure better outcomes. Control more upside.</h2>
          <p className="text-neutral-300 mt-5 leading-relaxed">
            Michael partners with owners and operators to unlock value across the full capital stack — combining commercial real estate, creative finance, and AI-powered media systems into a single strategic engine.
          </p>
          <ul className="mt-8 space-y-4">
            {PILLARS.map((p) => (
              <li key={p.title} className="flex gap-3">
                <Check className="text-[#CC5500] shrink-0 mt-1" size={18} />
                <span><strong className="text-white">{p.title}.</strong> <span className="text-neutral-400">{p.body}</span></span>
              </li>
            ))}
          </ul>
          <Link to="/book-call" className="btn-primary mt-10" data-testid="michael-book-call-btn">
            Book a Strategy Call <ArrowRight size={18} />
          </Link>
        </Reveal>
      </section>

      <section className="py-16 bg-[#0E0E0E] border-y border-white/10">
        <div className="max-w-3xl mx-auto px-6">
          <div className="card-edge p-8">
            <LeadForm formKey="strategy_call" sourcePage="/michael-brown" />
          </div>
        </div>
      </section>
    </Layout>
  );
}
